import { render, staticRenderFns } from "./PlayerModel.vue?vue&type=template&id=dd975714&scoped=true&"
import script from "./PlayerModel.vue?vue&type=script&lang=js&"
export * from "./PlayerModel.vue?vue&type=script&lang=js&"
import style0 from "./PlayerModel.vue?vue&type=style&index=0&id=dd975714&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd975714",
  null
  
)

export default component.exports